import React from 'react'
import { useSelector } from 'react-redux'
import { Field } from 'redux-form'
import { inputTypes } from '@easybutton/constants'

import { getTable } from '../../../ducks/databases'
import WrappedInput from '../../Shared/Forms/WrappedInput'
import SearchInput from '../../Shared/Forms/SearchInput'

const required = value => {
  return value ? undefined : 'Required'
}

const PrimaryKey = function PrimaryKeyInput({ input }) {
  let { databaseId, table: tableName } = input
  let table = useSelector(getTable(databaseId, tableName))

  if (!table) {
    return null
  }

  return (
    <Field
      name={input.id}
      component={SearchInput}
      placeholder={`Search ${table.name}...`}
      label={input.name}
      databaseId={databaseId}
      table={table}
      validate={[required]}
    />
  )
}

export default function Input({ input }) {
  if (input.type === inputTypes.PRIMARY_KEY) {
    return <PrimaryKey input={input} />
  }

  // Number, password, text
  const inputType = input.type

  return (
    <Field
      name={input.id}
      component={WrappedInput}
      placeholder={`Enter ${inputType}...`}
      label={input.name}
      type={inputType}
      validate={[required]}
    />
  )
}
